<template lang="pug">
    div
        slot(name="top-metadata")
            TableResultsCount(
                v-if="!isLoading && validItems && !hideCount"
                :is-many="isMany"
                :items="items"
                :outlined="!dark"
                :total-results="totalResults"
                :remove-outlined-row-count="removeOutlinedRowCount"
            )
        v-simple-table.table-x-scroll(:class="[tableClasses, darkThemeClass]" :id="'table-fixed-header'+key" fixed-header :height="tableHeight" :style="heightStyle")
            template(v-slot:default)
                slot(name="thead")
                    thead(:id="'table-fixed-header-head'+key")
                        template(v-if="superHeader")
                            slot(name="thead-super")
                                tr(:class="tableHeaderRowClass")
                                    slot(name="column-super-header-first")
                                        th.text-left.no-wrap(v-if="validNumOfStickyColumns && numOfStickyColumns > 0" :class="tableHeaderThClass")
                                            slot(name="column-super-header-first-title")
                                    slot(name="column-super-header-second")
                                        th.text-left.no-wrap(v-if="validNumOfStickyColumns && numOfStickyColumns > 1" :style="{ left: firstColumnWidth + 'px'}" :class="tableHeaderThClass")
                                            slot(name="column-super-header-second-title")
                                    template(v-if="dark")
                                        th.sticky-column(v-if="validNumOfStickyColumns" :style="{ left: stickyColumnLeft + 'px'}")
                                    template(v-else)
                                        th.sticky-column-white-background(v-if="validNumOfStickyColumns" :style="{ left: stickyColumnLeft + 'px'}")
                                    slot(name="th-super-default")
                        slot(name="thead-tr")
                            tr(:class="tableHeaderRowClass")
                                slot(name="column-header-first")
                                    th.text-left.no-wrap(v-if="validNumOfStickyColumns && numOfStickyColumns > 0" :id="'column-header-first'+key" :class="tableHeaderThClass")
                                        slot(name="column-header-first-title")
                                            | Created At
                                            v-icon(small color="white") mdi-chevron-down
                                slot(name="column-header-second")
                                    th.text-left.no-wrap(v-if="validNumOfStickyColumns && numOfStickyColumns > 1" :style="{ left: firstColumnWidth + 'px'}" :id="'column-header-second'+key" :class="tableHeaderThClass")
                                        slot(name="column-header-second-title")
                                            | Organization
                                template(v-if="dark")
                                    th.sticky-column(v-if="validNumOfStickyColumns" :style="{ left: stickyColumnLeft + 'px'}" :id="'column-header-sticky'+key")
                                template(v-else)
                                    th.sticky-column-white-background(v-if="validNumOfStickyColumns" :style="{ left: stickyColumnLeft + 'px'}" :id="'column-header-sticky'+key")
                                slot(name="th-default")
                                    //- EXAMPLE BELOW
                                    //- th.text-center.no-wrap Column Name 1

                slot(name="tbody" :tableKey="key")
                    TBodyDraggable(:draggable="draggable" :items="visibleItems" :onDraggableChange="onDraggableChange" :id="'table-fixed-header-body'+key")
                        template(v-slot:tbody-draggable)
                            slot(name="tbody-tr")
                                tr(v-for='(item, idx) in visibleItems' v-if='!isLoading && validItems' :key='(rowKey && item[rowKey]) ? item[rowKey] : idx' :class="[rowClass ? rowClass(item) : null, {'highlight': item.toBeHighlighted, 'disable-pointer': disableRows }]")
                                    slot(name="column-header-first-content" :item="item" )
                                        td.no-wrap.xs-width(v-if="validNumOfStickyColumns && numOfStickyColumns > 0")
                                            slot(name="column-header-first-content-value" :item="item")
                                                template(v-if='item["friendly_created_at"]') {{ item["friendly_created_at"] }}
                                                template(v-else) ---
                                    slot(name="column-header-second-content" :item="item")
                                        td.no-wrap.sm-width(v-if="validNumOfStickyColumns && numOfStickyColumns > 1" :style="{ left: firstColumnWidth + 'px'}")
                                            slot(name="column-header-second-content-value" :item="item")
                                                StrLimitTooltipText(:text='item["organization_name"]' :char-limit="30")
                                    td.sticky-column(v-if="validNumOfStickyColumns" :style="{left: stickyColumnLeft + 'px'}")
                                    slot(name="tr-default" :item="item" :idx="idx")
                                        //- Example Below
                                        //- td.no-wrap.xs-width
                                        //-     template(v-if="slotProps.item.field_1")
                                        //-         | {{ slotProps.item.field_1 }}
                                        //-     template(v-else) ---

                                tr(v-if="isLoading")
                                    td.text-center(colspan="100%")
                                        v-progress-circular(
                                            :size='100'
                                            :width='10'
                                            color='var(--volie-blue)'
                                            indeterminate
                                            style="margin-top: 75px; margin-bottom: 75px;"
                                        )

                            slot(name="total-row-tr")
                                tr#total-row.total-row-footer(v-if='!isLoading && validItems && totalRow' style="position: sticky; inset-block-end: 0; z-index: 4")
                                    slot(name="total-row-first-column-name")
                                        td.no-wrap.xs-width
                                            | Total
                                    //- Mirrors the body row's column-header-second-content slot so callers can render a value under the second sticky column (e.g. a "{count} rows" cell under the date column), instead of leaving it forced-empty. Default stays empty for backwards compatibility with existing consumers.
                                    td.no-wrap.xs-width(v-if="validNumOfStickyColumns && numOfStickyColumns > 1" :style="{ left: firstColumnWidth + 'px'}")
                                        slot(name="total-row-second-column-name")
                                    td.sticky-column(v-if="validNumOfStickyColumns" :style="{left: stickyColumnLeft + 'px'}")
                                    slot(name="total-row-tr-default")
                                        //- Example Below
                                        //- td.no-wrap.xs-width
                                        //-     template(v-if="slotProps.item.field_1")
                                        //-         | {{ slotProps.item.field_1 }}
                                        //-     template(v-else) ---


        slot(name="show-more-row")
            ShowMoreRow(
                v-if="!isLoading"
                :handle-show-more="handleShowMore"
                :id-key="key"
                :loading="isShowMoreLoading"
                :show-more="showMore"
            )

        template(v-if="enableVirtualScrolling && !isLoading")
            VirtualScrollIndicator(
                :handle-show-all="showAllRows"
                :id-key="key"
                :total-count="items.length"
                :visible-count="visibleRowCount"
            )

        slot(name="table-alert")

        template(v-if="footer")
            div(:id="'table-footer'+key")
                slot(name='table-footer')

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import ShowMoreRow from '@/components/shared/show_more_row_new.vue';
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";
    import TableResultsCount from "@/components/shared/table_results_count.vue";
    import TBodyDraggable from "@/components/shared/tbody_draggable.vue";
    import VirtualScrollIndicator from "@/components/shared/virtual_scroll_indicator.vue";

    // Imports
    import { v4 as uuidv4 } from 'uuid';
    import { throttle } from '@/helpers/coroutine';

    export default Vue.extend({
        data() {
            return {
                key: null,
                firstColumnWidth: 100,
                secondColumnWidth: 100,
                stickyColumnWidth: 2,
                tableHeight: 300,
                throttledScrollHandler: null,
                visibleRowCount: 50,
            }
        },
        methods: {
            calculateStringHeight(height) {
                let outgoing = 0;

                if (typeof height === 'string' && height.endsWith('vh')) {
                    const vhValue = parseFloat(height);
                    outgoing = (window.innerHeight * vhValue) / 100;
                } else {
                    outgoing = height;
                }

                return outgoing;
            },
            handleColumnStickyPosition() {
                this.firstColumnWidth = (document?.getElementById('column-header-first'+this.key)?.getBoundingClientRect()?.width || 0);
                this.secondColumnWidth = (document?.getElementById('column-header-second'+this.key)?.getBoundingClientRect()?.width || 0);
                this.stickyColumnWidth = (document?.getElementById('column-header-sticky'+this.key)?.getBoundingClientRect()?.width || 0);
            },
            handleSecondColumnStickyPosition() {
                this.firstColumnWidth = (document?.getElementById('column-header-first'+this.key)?.getBoundingClientRect()?.width || 0);
            },
            handleTableHeight() {
                // If dynamic height is disabled, use provided height or calculate a reasonable default
                if (this.noDynamicHeight) {
                    if (this.height) {
                        this.tableHeight = this.height;
                    } else if (this.maxHeight) {
                        this.tableHeight = this.calculateStringHeight(this.maxHeight);
                    } else {
                        this.tableHeight = this.calculateStringHeight('100vh');
                    }
                    return;
                }

                const tableTop = (document?.getElementById('table-fixed-header'+this.key)?.getBoundingClientRect()?.top || 0);
                let showMoreRowHeight = 0;
                if (this.showMore) {
                    showMoreRowHeight = (document?.getElementById('show-more-row'+this.key)?.getBoundingClientRect()?.height || 44);
                }

                let tableFooterRowHeight = 0;
                if (this.footer) {
                    tableFooterRowHeight = (document?.getElementById('table-footer'+this.key)?.getBoundingClientRect()?.height || 0);
                }

                if (tableTop > 0) {

                    let maxTableHeight = 0;
                    if (this.height > 0) { // If table height is set from prop, i.e. not dynamic to fill vertical space
                        maxTableHeight = this.height;
                    } else if (this.maxHeight) {
                        maxTableHeight = this.calculateStringHeight(this.maxHeight);
                    } else {
                        maxTableHeight = window.innerHeight - tableTop - showMoreRowHeight - 40; // 40 coming from padding
                    }

                    const tableHead = (document?.getElementById('table-fixed-header-head'+this.key)?.getBoundingClientRect()?.height || 0);
                    const tableBody = (document?.getElementById('table-fixed-header-body'+this.key)?.getBoundingClientRect()?.height || 0);
                    const tableHeight = tableHead+tableBody+tableFooterRowHeight

                    if (tableHeight > 0 && tableHeight < maxTableHeight) {
                        this.tableHeight = 'auto';
                    } else {
                        this.tableHeight = maxTableHeight;
                    }

                    if (this.tableHeight < 0) {
                        this.tableHeight = tableHeight;
                    }

                    if (this.minHeight > 0 && this.tableHeight < this.minHeight) {
                        this.tableHeight = this.minHeight;
                    }
                }
            },

            // Virtual scrolling methods
            //
            // Is tied to the on scroll event to detect
            // when the user reaches the bottom of the table
            handleTableScroll(event) {
                const element = event.target;
                const scrollTop = element.scrollTop;
                const scrollHeight = element.scrollHeight;
                const clientHeight = element.clientHeight;

                if (scrollHeight <= clientHeight) {
                    return;
                }

                const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

                if (scrollPercentage > this.scrollThreshold && this.visibleRowCount < this.items.length) {
                    this.loadMoreRows();
                }
            },
            handleWindowResize() {
                if (this.validNumOfStickyColumns) {
                    this.handleColumnStickyPosition();
                }

                this.handleTableHeight();
            },
            // updates the limit to display when the user scrolls to the bottom
            loadMoreRows() {
                const totalRows = this.items.length;
                const newVisibleCount = Math.min(this.visibleRowCount + this.rowsToAdd, totalRows);

                this.visibleRowCount = newVisibleCount;
            },
            resetVisibleRows() {
                this.visibleRowCount = this.initialRowCount;
            },
            showAllRows() {
                this.visibleRowCount = this.items.length;
            },
            // gets the element of the table that is scrollable
            // in order to attach the scroll event listener
            getScrollableElement() {
                const rootEl = this.$el;

                const selectors = [
                    '.v-simple-table',
                    '.v-data-table__wrapper',
                    '.table-x-scroll',
                    'table',
                    '[style*="overflow"]'
                ];

                for (const selector of selectors) {
                    const element = rootEl.querySelector(selector);
                    if (element) {
                        const computedStyle = window.getComputedStyle(element);
                        const hasScroll = computedStyle.overflow === 'auto' ||
                                        computedStyle.overflow === 'scroll' ||
                                        computedStyle.overflowY === 'auto' ||
                                        computedStyle.overflowY === 'scroll';

                        if (hasScroll || element.scrollHeight > element.clientHeight) {
                            return element;
                        }
                    }
                }

                const allElements = rootEl.querySelectorAll('*');
                for (const element of allElements) {
                    if (element.scrollHeight > element.clientHeight) {
                        return element;
                    }
                }

                return null;
            },
        },
        computed: {
            visibleItems() {
                if (!this.enableVirtualScrolling || !this.items) {
                    return this.items;
                }
                return this.items.slice(0, this.visibleRowCount);
            },
            darkThemeClass() {
                return this.darkTheme ? 'dark-theme' : '';
            },
            heightStyle() {
                if (this.noDynamicHeight) {
                    const styles = {};
                    if (this.maxHeight) {
                        styles['max-height'] = `${this.calculateStringHeight(this.maxHeight)}px`;
                    }
                    return styles;
                }

                return {};
            },
            itemsCount() {
                return this.items?.length || 0;
            },
            itemsCountDisplay() {
                if (this.itemsCount === 0) {
                    return 'No results';
                }

                return '1-'+this.itemsCount.toString();
            },
            stickyColumnLeft() {
                if (this.numOfStickyColumns === 1) {
                    return this.firstColumnWidth;
                }

                if (this.numOfStickyColumns === 2) {
                    return this.firstColumnWidth + this.secondColumnWidth;
                }

                return 0;
            },
            tableClasses() {
                if (this.numOfStickyColumns === 1) {
                    // first column + line/shadow column .sticky-column
                    return "sticky-col-inherit-1 sticky-col-inherit-2"
                }

                if (this.numOfStickyColumns === 2) {
                    // first column + second column + line/shadow column .sticky-column
                    return "sticky-col-inherit-1 sticky-col-inherit-2 sticky-col-inherit-3"
                }

                return "";
            },
            tableHeaderRowClass() {
                if (this.dark) {
                    return "volie-background-color-blue";
                }

                return "bg-white";
            },
            tableHeaderThClass() {
                if (this.dark) {
                    return "white--text";
                }

                return "";
            },
            validNumOfStickyColumns() {
                return this.numOfStickyColumns === 1 || this.numOfStickyColumns === 2;
            },
            validItems() {
                return this.items?.length > 0;
            },
        },
        components: {
            ShowMoreRow,
            StrLimitTooltipText,
            TableResultsCount,
            TBodyDraggable,
            VirtualScrollIndicator,
        },
        props: {
            dark: Boolean,   // dark = Blue table header row background, White table header text, light/default = White table header row background, Dark grey header text
            darkTheme: Boolean, // dark = Blue table header row background, White table header text, light/default = White table header row background, Dark grey header text
            disableRows: Boolean,  //Disable rows in the table such as in communitcation center for queues locked
            draggable: Boolean,
            footer: Boolean,
            isMany: Boolean,
            removeOutlinedRowCount: Boolean,
            handleShowMore: Function,
            height: {
                type: [Number, String],
                default: null
            }, // optional table height, if you don't want it to be dynamic
            hideCount: Boolean,
            isLoading: Boolean,
            isShowMoreLoading: Boolean,
            items: Array,
            maxHeight: {
                type: [Number, String],
                default: null
            },
            minHeight: {
                type: [Number, String],
                default: null
            }, // optional table min height, if you don't want it to be dynamic
            noDynamicHeight: {
                type: Boolean,
                default: false
            }, // disable dynamic height calculation, table will use natural height
            numOfStickyColumns: Number, // 2 max, for now
            onDraggableChange: Function,
            rowKey: String, // optional item property to key rows by (stable identity); falls back to index
            showMore: Boolean,
            showSnackbar: Function,
            superHeader: Boolean,
            totalResults: Number,
            totalRow: Boolean,
            rowClass: Function, // optional (item) => string | object; class(es) applied to each body row

            // Virtual scrolling props
            enableVirtualScrolling: {
                type: Boolean,
                default: false
            },
            initialRowCount: {
                type: Number,
                default: 50
            },
            rowsToAdd: {
                type: Number,
                default: 25
            },
            scrollThreshold: {
                type: Number,
                default: 0.95
            },
        },
        watch: {
            items: {
                handler() {
                    // Reset virtual scrolling when items change
                    if (this.enableVirtualScrolling) {
                        this.resetVisibleRows();
                    }

                    Vue.nextTick(() => {
                        if (this.validNumOfStickyColumns) {
                            this.handleColumnStickyPosition();
                        }

                        this.handleTableHeight();
                });
                },
                deep: true,
            },
            isLoading: {
                handler() {
                    Vue.nextTick(() => {
                        if (this.validNumOfStickyColumns) {
                            this.handleColumnStickyPosition();
                        }

                        this.handleTableHeight();
                    });
                },
            },
            showMore: {
                handler() {
                    Vue.nextTick(() => {
                        this.handleTableHeight();
                    });
                },
            },
            firstColumnWidth: {
                handler() {
                    if (this.validNumOfStickyColumns && this.numOfStickyColumns > 0) {
                        Vue.nextTick(() => { this.handleSecondColumnStickyPosition(); });
                    }
                },
            },
            secondColumnWidth: {
                handler() {
                    if (this.validNumOfStickyColumns && this.numOfStickyColumns > 1) {
                        Vue.nextTick(() => { this.handleColumnStickyPosition(); });
                    }
                },
            },
            numOfStickyColumns: {
                handler() {
                    // Recalculate sticky column positions when the number of sticky columns changes
                    Vue.nextTick(() => {
                        if (this.validNumOfStickyColumns) {
                            this.handleColumnStickyPosition();
                        } else {
                            // Reset widths if no valid sticky columns
                            this.firstColumnWidth = 0;
                            this.secondColumnWidth = 0;
                            this.stickyColumnWidth = 0;
                        }
                    });
                },
            },
        },
        created() {
            this.key = '-'+uuidv4();

            // Initialize virtual scrolling
            if (this.enableVirtualScrolling) {
                this.visibleRowCount = this.initialRowCount;
                this.throttledScrollHandler = throttle(this.handleTableScroll, 100);
            }

            window.addEventListener('resize', this.handleWindowResize);
        },
        destroyed() {
            // Remove virtual scrolling event listener
            if (this.enableVirtualScrolling && this.throttledScrollHandler) {
                const tableElement = this.getScrollableElement();
                if (tableElement) {
                    tableElement.removeEventListener('scroll', this.throttledScrollHandler);
                }
            }

            window.removeEventListener('resize', this.handleWindowResize);
        },
        mounted() {
            // Set up virtual scrolling event listener
            if (this.enableVirtualScrolling && this.throttledScrollHandler) {
                this.$nextTick(() => {
                    const tableElement = this.getScrollableElement();
                    if (tableElement) {
                        tableElement.addEventListener('scroll', this.throttledScrollHandler);
                    }
                });
            }

            setTimeout(() => {
                if (this.validNumOfStickyColumns) {
                    this.handleColumnStickyPosition();
                }

                this.handleTableHeight();
            }, 25);
        },
    });
</script>

<style lang="scss" scoped>
   #app {

    .dark-theme {
        // Style the header for dark theme
       &.sticky-col-inherit-1 table > tbody > tr > td:nth-child(1), #app .sticky-col-inherit-1 table > thead > tr > th:nth-child(1) {
            border: none;
        }

        thead {
            background-color: var(--dark-blue-70) !important;
            tr {
                background-color: var(--dark-blue-70) !important;
                color: white !important;
            }
            th {
                background-color: var(--dark-blue-70) !important;
                color: white !important;
            }
        }

        // Style the body rows for dark theme
        tbody {
            tr:not(.total-row-footer):not(.highlight) {
                &:nth-of-type(odd) {
                    background-color: var(--dark-blue-70) !important;
                }
                &:nth-of-type(even) {
                    background-color: var(--dark-blue-70) !important;
                }
                &:hover {
                    background-color: rgba(255, 255, 255, 0.1) !important;
                    ::v-deep td {
                        color: black !important;
                    }
                }
                ::v-deep td {
                    color: white;
                }
            }

            // Add specific styles for sticky columns
            ::v-deep .sticky-col-inherit-1 {
                table > tbody > tr > td:first-child {
                    box-shadow: none !important;
                    border-right: 1px solid rgba(245, 237, 237, 0.12) !important;
                    border-bottom: 1px solid rgba(245, 237, 237, 0.12) !important;
                }
            }

        }
    }
    tr.total-row-footer {
        background-color: var(--volie-gray) !important;
        color: white !important;
        font-weight: 500 !important;
    }

    tr#total-row.total-row-footer:hover {
        background-color: var(volie-gray) !important;
    }

    tr.highlight {
        background-color: #ffebe9 !important;
        ::v-deep td {
            color: black !important;
        }
    }



}
</style>
